import { render, staticRenderFns } from "./PokemonList.vue?vue&type=template&id=520b5bee&scoped=true&"
import script from "./PokemonList.vue?vue&type=script&lang=js&"
export * from "./PokemonList.vue?vue&type=script&lang=js&"
import style0 from "./PokemonList.vue?vue&type=style&index=0&id=520b5bee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520b5bee",
  null
  
)

export default component.exports